import * as React from 'react';
import { ProfileModalInterface } from '@/model/profile.mjs';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import { CreateStoreForm } from './createForm';
import ModalComponent from '@/common/Modal';

const CreateStore = ({ isOpen, onClose }: ProfileModalInterface) => {
  return (
    <>
      {isOpen && <ModalComponent
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <>
          </>
        }
        variant={2}
        title="Create new store"
        maxWidth="1138px"
        className='create-store-modal'
      >
        <CreateStoreForm onClosePopUp={onClose} />
      </ModalComponent>
      }
    </>
  );
};

export default CreateStore;
